import {useState} from "react";
import classNames from "classnames";

import {IOptionValue} from "../types/IOptionValue";
import {IRadioGroupProps} from "../types/IRadioGroupProps";
import {Radio} from "./Radio";

import {listItemStyle, radioListStyle} from "./RadioGroup.module.css";

export function RadioGroup(props: IRadioGroupProps) {
    const {className, radioClassName, optionClassName, name, options, value, onChange, radioRender} = props;
    const [selectedValue, setSelectedValue] = useState<IOptionValue | null>(value ?? null);
    const radioListCN = classNames(radioListStyle, className);
    const radioListItemCN = classNames(listItemStyle, optionClassName);

    const onRadioChange = (_name: string, _isActive: boolean, value: IOptionValue) => {
        setSelectedValue(value as IOptionValue);

        if (onChange) {
            onChange(value as IOptionValue);
        }
    };

    return (
        <ul className={radioListCN}>
            {options.map((option, index) => {
                const selectionId = `ro_${name}_${option.value}`;
                const isActive = selectedValue === option.value;

                return (
                    <li key={`ro_k_${name}_${index}`} className={radioListItemCN}>
                        {radioRender ? (
                            radioRender({
                                name,
                                value: option.value,
                                id: selectionId,
                                isActive,
                                onChange: (name, checked, value) => {
                                    onRadioChange(name, checked, value as IOptionValue);
                                },
                                labelContent: option.labelContent,
                                className: radioClassName
                            })
                        ) : (
                            <Radio
                                name={name}
                                id={selectionId}
                                value={option.value}
                                isActive={isActive}
                                onChange={(name, checked, value) => {
                                    onRadioChange(name, checked, value as IOptionValue);
                                }}
                                labelContent={option.labelContent}
                                className={radioClassName}
                            />
                        )}
                    </li>
                );
            })}
        </ul>
    );
}
import {useState} from "react";
import classNames from "classnames";

import {IOptionValue} from "../types/IOptionValue";
import {IRadioGroupProps} from "../types/IRadioGroupProps";
import {Radio} from "./Radio";

import {listItemStyle, radioListStyle} from "./RadioGroup.module.css";

export function RadioGroup(props: IRadioGroupProps) {
    const {className, radioClassName, optionClassName, name, options, value, onChange, radioRender} = props;
    const [selectedValue, setSelectedValue] = useState<IOptionValue | null>(value ?? null);
    const radioListCN = classNames(radioListStyle, className);
    const radioListItemCN = classNames(listItemStyle, optionClassName);

    const onRadioChange = (_name: string, _isActive: boolean, value: IOptionValue) => {
        setSelectedValue(value as IOptionValue);

        if (onChange) {
            onChange(value as IOptionValue);
        }
    };

    return (
        <ul className={radioListCN}>
            {options.map((option, index) => {
                const selectionId = `ro_${name}_${option.value}`;
                const isActive = selectedValue === option.value;

                return (
                    <li key={`ro_k_${name}_${index}`} className={radioListItemCN}>
                        {radioRender ? (
                            radioRender({
                                name,
                                value: option.value,
                                id: selectionId,
                                isActive,
                                onChange: (name, checked, value) => {
                                    onRadioChange(name, checked, value as IOptionValue);
                                },
                                labelContent: option.labelContent,
                                className: radioClassName
                            })
                        ) : (
                            <Radio
                                name={name}
                                id={selectionId}
                                value={option.value}
                                isActive={isActive}
                                onChange={(name, checked, value) => {
                                    onRadioChange(name, checked, value as IOptionValue);
                                }}
                                labelContent={option.labelContent}
                                className={radioClassName}
                            />
                        )}
                    </li>
                );
            })}
        </ul>
    );
}
